import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Customer360Service } from 'src/app/private/services/customer-360.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadActivityFeedItem } from '../lead-activity-feed/lead-activity-feed.component';

@Component({
  selector: 'app-lead-profile-feedback',
  templateUrl: './lead-profile-feedback.component.html',
  styleUrls: ['./lead-profile-feedback.component.scss'],
})
export class LeadProfileFeedbackComponent implements OnChanges {
  @Input() leadId: number | string | null = null;
  @Input() refreshToken = 0;
  @Output() changed = new EventEmitter<void>();

  items: LeadActivityFeedItem[] = [];
  loading = false;
  saving = false;
  feedbackText = '';
  rating: number | null = null;

  constructor(
    private customer360: Customer360Service,
    private localStorage: LocalStorageService,
    private toast: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leadId'] || changes['refreshToken']) {
      this.load();
    }
  }

  load(): void {
    if (this.leadId == null || this.leadId === '') {
      return;
    }
    this.loading = true;
    this.customer360.getCustomerFeedback(this.leadId).subscribe({
      next: (res: any) => {
        const rows = res?.rows ?? [];
        this.items = rows.map((row: any) => ({
          id: row.id,
          actorName: row.rating != null ? `Rating ${row.rating}/5` : 'Feedback',
          createdAt: row.createdAt,
          body: row.feedback_text,
          raw: row,
        }));
        this.loading = false;
      },
      error: () => {
        this.items = [];
        this.loading = false;
      },
    });
  }

  submit(): void {
    if (!this.feedbackText.trim() || this.leadId == null) {
      return;
    }
    this.saving = true;
    this.customer360
      .createCustomerFeedback(this.leadId, {
        feedback_text: this.feedbackText.trim(),
        rating: this.rating ?? undefined,
        created_by: Number(this.localStorage.getUserId()) || undefined,
      })
      .subscribe({
        next: () => {
          this.feedbackText = '';
          this.rating = null;
          this.saving = false;
          this.toast.success('Feedback saved');
          this.load();
          this.changed.emit();
        },
        error: () => {
          this.saving = false;
          this.toast.error('Could not save feedback');
        },
      });
  }
}
